import { render, staticRenderFns } from "./CheckoutBtn.vue?vue&type=template&id=d21be256&scoped=true&"
import script from "./CheckoutBtn.vue?vue&type=script&lang=js&"
export * from "./CheckoutBtn.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutBtn.vue?vue&type=style&index=0&id=d21be256&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21be256",
  null
  
)

export default component.exports